import { AdvancedSwitch } from '@dealstack/frontend/shared/components/Switch/AdvancedSwitch';
import { Group } from '@mantine/core';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

interface Props {
	label: string;
	active: boolean;
	disabled?: boolean;
	labelSide?: 'left' | 'right';
	onToggle: (enabled: boolean) => void;
}

// Not AdvancedSwitch's `selectedColor`: it emits `!important` in a style object,
// which React drops, so its own label colours never reach the DOM.
const StatusLabel = styled.span<{ $active: boolean }>`
	font-size: 0.75rem;
	font-weight: ${({ $active }) => ($active ? 500 : 400)};
	color: ${({ $active }) =>
		$active ? 'var(--mantine-color-dark-8)' : 'var(--mantine-color-gray-9)'};
`;

export const TemplateStatus = ({
	label,
	active,
	disabled,
	labelSide = 'right',
	onToggle,
}: Props) => {
	const [checked, setChecked] = useState(active);

	useEffect(() => {
		setChecked(active);
	}, [active]);

	const text = <StatusLabel $active={checked}>{label}</StatusLabel>;

	return (
		<Group
			gap="xs"
			wrap="nowrap"
			onClick={(event) => event.stopPropagation()}
			style={{ width: 'fit-content' }}
		>
			<AdvancedSwitch
				selectedValue={checked}
				disabled={disabled}
				leftText={labelSide === 'left' ? text : undefined}
				rightText={labelSide === 'right' ? text : undefined}
				onChange={() => {
					setChecked((previous) => !previous);
					onToggle(!checked);
				}}
			/>
		</Group>
	);
};
